<template>
    <div class="mini-calendar__calendar" >
        <VDatePicker borderless ref="datepicker"  v-model="range" @update:modelValue="dayclick" @update:pages="popover"  :attributes= "month_events"/>
    </div>
</template>

<script>
import moment from 'moment'
import { getFilteredEvents } from './../api'
import { mapActions, mapGetters } from 'vuex'
import { DATE_FORMAT } from '@/utils/config'
import { generateStaticDay } from './../utils/util';

export default {
  name: 'MiniCalendarCalendar',
  data() {
    return {
      range: new Date(),
      is_mounted: false,
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear()
    };
  },
  computed: {
    ...mapGetters(['date_range', 'month_events'])
  },
  watch: {
    date_range: function (newVal) {
      if (newVal.type != "custom_range") {
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;

        this.month = month;
        this.year = year;
        this.$refs.datepicker.move({month: month, year: year})

        if (newVal.start != moment(this.range).format(DATE_FORMAT) || newVal.end != moment(this.range).format(DATE_FORMAT)) {
          this.is_mounted = true;
          this.range = new Date();
        }
      }
    }
  },
  methods: {
    filterEvents(start, end) {
      this.setLoading(true);
      const formatted_start = start.format(DATE_FORMAT),
      formatted_end = end.format(DATE_FORMAT);

      if (formatted_start != formatted_end) {
        let filtered = this.month_events.filter((item) => item.id == formatted_start);
        if (!filtered.length) {
          getFilteredEvents(formatted_start, formatted_end, [], 0).then((response) => {
            if (response) {
              let data = response.data ? response.data : [];
              let dates = [];
              for (let event of data) {
                dates.push(moment(event.date.start.date).toDate());
              }

              this.setMonthEvents([
                ...this.month_events,
                generateStaticDay( dates,  formatted_start)
              ]);
            }
          });
        }
      }

      getFilteredEvents(formatted_start, formatted_end).then((response) => {

        if (response) {
          let data = response.data ? response.data : [];

          this.setEventList({eventlist: data, total: response.query.total})
          this.setDateRange({
              type: 'custom_range',
              start: formatted_start,
              end: formatted_end
          });
        }

        this.setLoading(false);
      }).catch(()=> {
        this.setLoading(false);
      });

    },
    dayclick(e) {
      if (this.is_mounted) {
        this.is_mounted = false;
        return;
      }

      this.filterEvents(moment(e), moment(e));
    },
    popover(e) {
      if (e.length > 0) {
        e = e[0];
      }

      if (e.year == this.year && e.month == this.month) {
        return;
      }

      this.year = e.year;
      this.month = e.month;

      let start = moment(`${e.year}-${e.month}-01`);
      const endofday = start.daysInMonth();
      const end = moment(`${e.year}-${e.month}-${endofday}`);

      this.filterEvents(start, end);
    },
    ...mapActions(['setDateRange', 'setEventList', 'setLoading', 'setMonthEvents'])
  }
}
</script>

<style lang="scss">
    .vc-header .vc-arrow,
    .vc-header .vc-title {
      background: transparent;
    }
    .mini-calendar__calendar {
      display: none;
      width: 100%;
      padding: rem(20);


      &> div:first-child {
          width: 100%;
      }

      .vc-title {
        text-align: center;
      }

      @include tablet-up {
        display: block;
      }

      .vc-weeks {
        .vc-weekday {
          color: #000;
        }
      }

      .is-today {
        &.vc-day {
          span {
            background-color: $background-color3;
          }
        }
      }
    }
</style>